import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import ReturnsApi from '../../../../API/shipment/returns-api';
import { Column, NavTabs, Row, WhiteBlock } from '../../../../components/Basic/Blocks';
import { Button } from '../../../../components/Basic/Buttons';
import { LinkBlue } from '../../../../components/Basic/Elements';
import { Content, PageTitle } from '../../../../components/Basic/Global';
import { Input, Select } from '../../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader, TablePagination } from '../../../../components/Basic/Table';
import { H1, Text } from '../../../../components/Basic/WrapsStyle';
import {
  MAP_SKLAD_RUS,
  RETURN_STATUS_LIST,
  SKLAD_LIST,
  TYPE_BUTTONS,
  TYPE_RETURNS
} from '../../../../constans';
import { getDate } from '../../../../utils';
import ReturnsLine from '../../../Warehouse/ReturnsEntry/Line';
import styles from './styles.module.scss';


const SHOPS = {
  ozon: ['Все', 'ozon1', 'ozon2', 'ozon3', 'ozon4', 'ozon5', 'ozon6', 'ozon7'],
  yandex: ['Все', 'yandex1', 'yandex3', 'yandex4', 'yandex5', 'yandex6', 'yandex7', 'yandex8'],
  wb: ['Все', 'wb1', 'wb2', 'wb3', 'wb4', 'wb5', 'wb6', 'wb7'],
  megamarket: ['Все', 'megamarket1', 'megamarket2'],
  Ozon: ['Все', 'ozon1', 'ozon2', 'ozon3', 'ozon4', 'ozon5', 'ozon6', 'ozon7'],
  Yandex: ['Все', 'yandex1', 'yandex3', 'yandex4', 'yandex5', 'yandex6', 'yandex7', 'yandex8'],
  Wb: ['Все', 'wb1', 'wb2', 'wb3', 'wb4', 'wb5', 'wb6', 'wb7'],
  Megamarket: ['Все', 'megamarket1', 'megamarket2'],
};

export const MARKETS_LIST = ['Не выбрана', 'Ozon', 'Wb', 'Yandex', 'Megamarket', 'Avito'];;

const MODES = ['Режим отгрузки', 'Режим докупов', 'Честный знак'];
const MODES_OWNER = ['Режим отгрузки', 'Режим докупов', 'Честный знак', 'Финансы'];

export const WIDTH_POSTING = [
  '150px', // 0
  '400px', // 1
  '200px', // 2
  '200px', // 3
  '180px', // 4
  '127px', // 5
  '120px', // 6
  '220px', // 7
  '100px', // 8
  '40px', // 9
  '100px', // 10
  '220px', // 11
  '80px', // 12
  '210px', // 13
];

const FILTER = {
  0: 'all_returns',
  1: 'returned',
  2: 'cancelled',
};

function ReturnsReportPage() {
  const { id } = useParams();

  const user = useSelector((store) => store.user);
  const [report, setReport] = useState({ market: '', shop: '', date_realization: '' });
  const [checkAll, setCheckAll] = useState(false);
  const [sklad, setSklad] = useState(SKLAD_LIST[0]);
  const [typeReturn, setTypeReturn] = useState(TYPE_RETURNS[0]);

  const [shop, setShop] = useState('');

  const [market, setMarket] = useState(MARKETS_LIST[0]);
  const [count, setCount] = useState([]);
  const [page, setPage] = useState(1);

  const [show, setShow] = useState(20);
  const [search, setSearch] = useState('');

  const [countStock, setCountStock] = useState([0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [provider, changeProvider] = useState({ name: 'Не выбран', id: null });
  const allProviders = useSelector((store) => store.providers);
  const [providers, setProviders] = useState([]);
  const [returns, setReturns] = useState({ ids: [], byId: {} });
  const [map, setMap] = useState({});

  const [orderStatus, changeOrderStatus] = useState('Не выбран');

  let changeState = async (ids, field, value) => {
    await ReturnsApi.changeReturns({ data: { returnIds: ids, field, value } }).then((res) => {
      let byIds = {};
      res.returns.forEach((item) => (byIds[item._id] = item));
      setReturns({ ids: returns.ids, byId: { ...returns.byId, ...byIds } });

    });
  };
  const clickCheckAll = (flag) => {
    if (flag) {
      const map_print = {};
      returns.ids.forEach((item) => {
        const order = returns.byIds[item];
        /*  const is_disabled_print = isDisabledPrint(order);

        if (!is_disabled_print) {
          map_print[order.posting_number] = true;
        } */
      });
      // setPostingsPrint(map_print);
      setCheckAll(true);
    } else {
      setCheckAll(false);

      // setPostingsPrint({});
    }
  };

  const onChangePage = (v) => {
    setPage(v);
  };

  const onChangeTab = (n) => {
    setTab(n);
  };

  const onClickConfirmReturns = async () => {
    await ReturnsApi.confirmReportReturn({ data: { reportReturnId: report.id } })
  };

  const params = useMemo(() => {
    let reportReturnsIds;

    reportReturnsIds = id.split('&');
    reportReturnsIds = reportReturnsIds.map((item) => parseInt(item));

    return {
      reportReturnsIds,
      tab: FILTER[tab],
      limit: parseInt(show),
      search: search.trim(),
      providerId: provider.id,
      type: 'return',
      market: market === 'Не выбрана' ? undefined : market.toLowerCase(),
      shop: shop === 'Все' ? undefined : shop.toLowerCase(),
      skladName: sklad === 'Все' ? undefined : MAP_SKLAD_RUS[sklad],
      filters: {
        returnStatus: orderStatus === 'Не выбран' ? undefined : orderStatus,
        returnType: typeReturn === 'Не выбран' ? undefined : typeReturn,
      },
    };
  }, [id, tab, show, search, provider.id, market, shop, orderStatus, sklad, typeReturn]);


  const loadData = () => {
    ReturnsApi.getReportItemsReturns({ data: params })
      .then((res) => {
        const { data, returns, cardsMap, count, all_count, reportReturns } = res;
        setCountStock([all_count.all_returns, all_count.returned, all_count.cancelled]);

        console.log(res);
        const ids = returns.map((item) => item._id);
        let byIds = {};
        returns.forEach((item) => (byIds[item._id] = item));

        setReturns({ ids, byId: byIds });

        //setPostingsPrint({});

        if (reportReturns.length === 1) {
          setReport(reportReturns[0]);
        } else {
          setReport(reportReturns);
        }

        setMap(cardsMap);

        setCount(count);
        // setShop(MARKETS_ALL[reportReturns[0].market][0]);
      })
      .catch((err) => {
        console.log(err);
        if (err.code === 140) {
          setError('Не удалось отгрузку');
        }
      });
  };

  useEffect(() => {
    loadData();
  }, [params]);

  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide);
    if (p.length > 0) {
      setProviders([{ name: 'Не выбран', id: null }, ...p]);
      changeProvider({ name: 'Не выбран', id: null });
    } else {
      changeProvider({ name: '' });
    }
  }, [allProviders]);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  const modes = isOwner ? MODES_OWNER : MODES;

  useEffect(() => {
    setShop('Все');
  }, [market]);

  const header_text = `Возвраты от ${getDate(report.date_report_return)}`;

  return (
    <>
      <PageTitle title={header_text} />
      <Content>
        <H1 style={{ marginBottom: '-3px' }}>{header_text}</H1>
        <LinkBlue to={'/report/returns/'} style={{ marginBottom: '10px' }}>
          Вернуться к отчетам по возвратам
        </LinkBlue>

        <Row style={{ alignItems: 'flex-start' }}>
          <WhiteBlock style={{ minWidth: '600px', alignSelf: 'normal' }} minimize={false}>
            <Row style={{ marginTop: '10px' }}>
              <Column>
                <Row style={{ marginTop: '15px' }}>
                  <Button type={TYPE_BUTTONS.GREEN} onClick={() => onClickConfirmReturns()}>Учесть возвраты в отчетах</Button>
                </Row>
              </Column>
              <Column style={{ marginTop: '14px' }}></Column>
            </Row>
          </WhiteBlock>
        </Row>

        <WhiteBlock className={styles.search_block}>
          <Row className={styles.navigate_table}>
            <NavTabs
              open_tab={tab}
              tabs={['Все возвраты', 'Возвраты от клиента', 'Невыкупы']}
              isNum={true}
              num={countStock}
              style_tab={styles.style_tab}
              onChange={onChangeTab}
            />
          </Row>

          <Row className={styles.row_input}>
            <Input value={search} onBlur={(v) => setSearch(v)} onClickEnter={(v) => setSearch(v)} label="Поиск" />
          </Row>

          <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>

          <Row spaceBetween={true}>
            <Row style={{ height: '40px' }}>
              <div>
                <Select
                  label="Показать на странице"
                  select={show}
                  list={['20', '50', '100', '150', '200', '500', '1000']}
                  onSelect={(v) => setShow(v)}
                  width="150px"
                  style={{ marginRight: '15px' }}
                />
              </div>
              <Select
                list={MARKETS_LIST}
                select={market}
                label="Площадка"
                onSelect={(v) => setMarket(v)}
                width={'150px'}
                style={{ marginRight: '15px' }}
              />
              <Select
                list={SHOPS[market]}
                select={shop}
                disabled={market === MARKETS_LIST[0]}
                label="Магазин"
                onSelect={(v) => setShop(v)}
                width={'150px'}
                style={{ marginRight: '15px' }}
              />
              <Select
                label="Поставщик"
                select={provider}
                valueFn={(p) => p.name}
                list={providers}
                width="200px"
                onSelect={(v) => changeProvider(v)}
                style={{ marginRight: '15px' }}
              />
              <Select
                list={SKLAD_LIST}
                select={sklad}
                label="Склад отгрузки"
                onSelect={(v) => setSklad(v)}
                width={'200px'}
                style={{ marginRight: '15px' }}
              />

              <Select
                label="Тип возврата"
                select={typeReturn}
                list={TYPE_RETURNS}
                width="200px"
                onSelect={(v) => setTypeReturn(v)}
                style={{ marginRight: '15px' }}
              />
              <Select
                label="Статус возврата"
                select={orderStatus}
                list={RETURN_STATUS_LIST}
                width="200px"
                onSelect={(v) => changeOrderStatus(v)}
              />
            </Row>
          </Row>
        </WhiteBlock>

        <Table styles={styles.table}>
          <TableHeader whiteHeader>
            <HeaderTitle width={WIDTH_POSTING[9]}></HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[0]}>Номер возврата / заказа</HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[12]} centerText>Дата возврата</HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[1]}>Позиции в заказе</HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[12]} centerText={true}>Количество</HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>Статус занесения</HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>Поставщик</HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>Тип возврата</HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>Статус возврата</HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[1]}>Причина возврата / Адрес получения</HeaderTitle>
          </TableHeader>
          {returns.ids.map((r) => {
            return (
              <ReturnsLine
                mode={'REPORT'}
                order={returns.byId[r]}
                map={map}
                key={returns.byId[r]._id}
                changeState={changeState}
              />
            );
          })}
        </Table>
        <TablePagination num={Math.ceil(count / show) || 1} show={page} onChange={onChangePage} />
      </Content>
    </>
  );
}

export default ReturnsReportPage;
